module.exports = __webpack_public_path__ + "assets/img/7c1b-uz.svg";